import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {Storage} from "@ionic/storage";
import {Product} from '../../entities/product';
import {StyleService, StyleType} from '../../services/style.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit, OnDestroy {
  public readonly StyleType = StyleType;

  @Input()
  price: number;
  product_name: string;
  selectedAdditions: Product[] = [];

  QRCode: string;

  timer = 60;
  interval;

  orderText = "";

  constructor(
      private modalCtrl: ModalController,
      private storage: Storage,
      public styleService: StyleService) { }

  ngOnInit() {
    this.storage.get('pos_id').then(pos_id => {
      this.QRCode = "mobilepaypos://pos?id=" + pos_id + "&source=qr";
    })

    this.interval = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        this.dismiss('timer')
      }
    }, 1000)
    this.orderText = `${this.product_name || '-'} - ${(this.price) || '-'} kr.`;
    if (this.selectedAdditions && this.selectedAdditions.length > 0) {
      this.selectedAdditions.forEach(add => {
        this.orderText += `, ${add.name || '-'} - ${(add.price) || '-'} kr.`;
      })
    }
  }

  ngOnDestroy() {
    clearInterval(this.interval)
  }

  dismiss(status) {
    clearInterval(this.interval);
    this.modalCtrl.dismiss({
      'status': status
    })
  }
}
